import { render, staticRenderFns } from "./CreateDataCenterComponent.vue?vue&type=template&id=d9ab9f3e&lang=pug"
import script from "./CreateDataCenterComponent.vue?vue&type=script&lang=js"
export * from "./CreateDataCenterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9ab9f3e')) {
      api.createRecord('d9ab9f3e', component.options)
    } else {
      api.reload('d9ab9f3e', component.options)
    }
    module.hot.accept("./CreateDataCenterComponent.vue?vue&type=template&id=d9ab9f3e&lang=pug", function () {
      api.rerender('d9ab9f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/datacenter/CreateDataCenterComponent.vue"
export default component.exports